(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bilago-detail-navigation"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-bilago-detail-nav]').forEach((nav) => {
      if (nav.dataset.bound) return;
      nav.dataset.bound = 'true';
      const links = Array.from(nav.querySelectorAll('[data-detail-target]'));
      const targetFor = (link) => document.getElementById((nav.dataset.sectionPrefix || '') + (link.dataset.detailTarget || ''));
      const wrapper = nav.closest('.bilago-detail-navigation');
      const visibleHeaderHeight = () => {
        const header = document.querySelector('header.header');
        if (!header) return 0;
        const bounds = header.getBoundingClientRect();
        return Math.max(0, Math.min(bounds.height, bounds.bottom));
      };
      let scheduled = false;
      const update = () => {
        scheduled = false;
        if (!nav.isConnected) return;
        const available = links.filter((link) => {
          const target = targetFor(link);
          const usable = Boolean(target && target.getBoundingClientRect().height > 0);
          link.setAttribute('aria-disabled', String(!usable));
          if (!usable) link.removeAttribute('aria-current');
          return usable;
        });
        wrapper?.style.setProperty('--bilago-detail-header-offset', `${visibleHeaderHeight()}px`);
        const edge = nav.getBoundingClientRect().bottom + 32;
        let active = available[0];
        available.forEach((link) => {
          if (targetFor(link)?.getBoundingClientRect().top <= edge) active = link;
        });
        available.forEach((link) => {
          if (link === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      const schedule = () => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      };
      nav.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const link = event.target.closest('[data-detail-target]');
        if (!link || !nav.contains(link)) return;
        const target = targetFor(link);
        event.preventDefault();
        if (!target || target.getBoundingClientRect().height <= 0) return;
        const headerHeight = visibleHeaderHeight();
        let layoutTop = 0;
        let node = target;
        while (node) { layoutTop += node.offsetTop; node = node.offsetParent; }
        const top = layoutTop - headerHeight - nav.getBoundingClientRect().height - 12;
        window.scrollTo({top:Math.max(0, top), behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      document.addEventListener('scroll', schedule, {passive:true});
      window.addEventListener('resize', schedule, {passive:true});
      document.addEventListener('transitionend', schedule, true);
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(schedule);
        links.forEach((link) => { const target = targetFor(link); if (target) observer.observe(target); });
      }
      update();
    });
  };
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();

  } catch(e) { console.error(e); }
})();
})();
